import * as yup from 'yup';

// use this schema if it's determined the customer is BC/Legacy
export const legacySchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required('Email is required')
    .email('Invalid email address'),
  password: yup.string().trim().required('Password is required'),
});

// start with this schema as a default for validation
export const emailSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required('Email is required')
    .email('Invalid email address'),
});
